<template>
<article class="info-section elr-container-full">
  <div class="elr-row">
    <div class="elr-col-full">
      <div class="info-section-header">
        <h1 class="info-section-heading">Administrator Dashboard</h1>
      </div>
    </div>
    <div class="elr-col-full">
      <h2 class="info-section-subheading">Activity Feed</h2>
      <ul class="activity-feed">
        <li v-for="action in activity" :key="action.id">{{action.username}} - {{action.title}} - {{action.activity_date}}</li>
      </ul>
    </div>
    <div class="elr-col-full">
      <h2 class="info-section-subheading">User List</h2>
      <ul class="user-list">
        <li
          :key="user.id"
          v-for="user in users"
        >
          {{user.id}}: {{user.username}} - {{user.created_at}} <router-link :to="`/user/${user.id}`">View</router-link>
        </li>
      </ul>
    </div>
  </div>
</article>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AdminDashboard',
  computed: {
    ...mapState({
      user: state => state.currentUser.currentUser,
      authenticated: state => state.currentUser.authenticated,
      activity: state => state.user.activity,
      users: state => state.user.users
    })
  }
}
</script>
